/**
 * Check if the DOM has fully loaded and run a function
 * @param {function} callback
 */
 const ready = (callback) => {
   if(document.readyState != 'loading') {
       callback();
   } else {
       document.addEventListener('DOMContentLoaded', callback);
   }
}

ready(() => {
   window.addEventListener("DOMContentLoaded", function() {
      const swiper_text = new Swiper('.slider-text .swiper-container', {
         spaceBetween: 30,
         effect: "fade",
         loop: true,
         fadeEffect: { crossFade: true },
      });
   });
});